import { Box, Stack, useBreakpointValue } from '@chakra-ui/react'
import React, { ReactElement } from 'react'

export interface ResultItemProps {
  subtitle?: ReactElement | ReactElement[]
  title: ReactElement | ReactElement[]
}

export const ResultItem = ({ subtitle, title }: ResultItemProps) => {
  const showDivider = useBreakpointValue({
    base: false,
    sm: true,
  })

  return (
    <Box _hover={{ bg: 'neutral.10' }} px={8} py={2}>
      <Stack
        direction={{ base: 'column', sm: 'row' }}
        divider={showDivider ? <>{` | `}</> : undefined}
        flexWrap="wrap"
        spacing={0}
        textStyle={['text.sm', 'text.md']}
        whiteSpace="pre-wrap"
      >
        {title}
      </Stack>
      {subtitle && (
        <Stack
          color="neutral.50"
          direction={{ base: 'column', sm: 'row' }}
          divider={showDivider ? <>{` | `}</> : undefined}
          flexWrap="wrap"
          spacing={0}
          textStyle="text.sm"
          whiteSpace="pre-wrap"
        >
          {subtitle}
        </Stack>
      )}
    </Box>
  )
}
